import { HttpException, HttpStatus, Injectable } from '@nestjs/common';
import { UserEntity} from './user.entity';
import {getConnection, LessThan, MoreThan, Raw, Repository} from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import {UserDto,LoginUserDto,CreateUserDto, SetPinDto, OtpDto, SignUpDto, VerifyOtpDto, UserRoleDto, UserIdDto,  userSearchDto, bGroupSearchDto,} from './dto/user.dto';
import * as bcrypt from 'bcrypt'; 
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { ProfileService } from '../profile/profile.service';
import { AllUserStatus, LoginStatus, OtpStatus, RegistrationStatus, searchResponseModel, UserStatus, UserStatusWiseResponseModel } from './dto/registraton.dto';
import { sendFCMNotifications, sendMailInfo, sendTextLocalSMS } from '../shared/mobileOTP';
import { HierarchyService } from '../hierarchy/hierarchy.services';
import { JwtPayload } from '../auth/jwt.payload';
import {JwtService} from '@nestjs/jwt';
import { RolesEntity } from '../roles/roles.entity';
import { UserOtp } from './user-otp.entity';
import 'dotenv/config';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { skip } from 'rxjs/operators';

@Injectable()
export class UserService {
  constructor(
    @InjectRepository(UserOtp)
    private readonly uotpRepo: Repository<UserOtp>,
    @InjectRepository(UserEntity)    
    private readonly userRepo: Repository<UserEntity>,
    @InjectRepository(RolesEntity)
    private readonly roleRepo:Repository<RolesEntity>,
    @InjectRepository(NotificationsEntity)
    private readonly notifyRepo:Repository<NotificationsEntity>,
    private readonly profileService: ProfileService, 
    private readonly hierarchyService: HierarchyService,
    private readonly jwtService: JwtService,

  ) {}

  async sendNotify(text) {
    return await sendFCMNotifications(text)
    .then(() => {      
      console.log('notification sent successufully');
      return true;
    })
    .catch((err) => {
      console.log('error in sending notification ', err);
      return false;
    });
  }

  async findOne(options?: object): Promise<UserDto> {
    console.log('opt',options);
    const user =  await this.userRepo.findOne(options);    
    return user;  
  }

  async findByPayload({ mobileNo }: any): Promise<UserDto> {
    return await this.findOne({ where: { mobileNo:mobileNo, status:true } });  
  }

  async checkPhoneNumber(mobileNo) {
    const result = await this.userRepo.find({
      where: {
        mobileNo: mobileNo, status:true
      }
    });
    return result.length === 0 ? false : true;
  }

  async sendSMS(mobileNo:string, text: string, id: string) {
    return await sendTextLocalSMS(mobileNo, text, id)
    .then(() => {      
      console.log('sms sent successufully');
      return true;
    })
    .catch((err) => {
      console.log('error in sending sms ', err);
      return false;
    });
  }

  async create(queryParams,userDto: CreateUserDto,profilePic,memberPic): Promise<RegistrationStatus> {  
    const response = new RegistrationStatus();  
    
    try {
      const userExists = await this.checkPhoneNumber(userDto.mobileNo);
      if(userExists) {
        throw new ErrorResponse(11104, 'mobileno already exists');
      } else {
        if(userDto.BGroupId > 0) {
          userDto.BGroupId = userDto.BGroupId
        } else {
          userDto.BGroupId = null;
        }
        if(profilePic) {
          userDto.otherPic = profilePic[0];
        } else {
          userDto.otherPic = null;
        }
        if(memberPic) {
          userDto.membershipImg = memberPic[0];
        } else {
          userDto.membershipImg = null;
        }
        if(queryParams.apiVersion == 1) {  
          userDto.createdUser = userDto.userId;
          var word = userDto.mobileNo.toString();          
          var subword = word.substr(word.length-4);
          userDto.pin = await bcrypt.hash(subword, 10)
          const savedUser = await this.userRepo.save({
            membershipId:userDto.membershipId,
            mobileNo:userDto.mobileNo,
            isPinSet:true,
            pin: userDto.pin,
            roleId:userDto.roleId,
            createdUser:userDto.userId,
            versionFlag:userDto.versionFlag
          });          
          if(savedUser.Id > 0) {
            const profileData = {
              firstName:userDto.firstName,
              lastName:userDto.lastName,
              gender:userDto.gender,
              dob:userDto.dob,
              address:userDto.address,
              villageId:userDto.villageId,
              mobileNo:userDto.mobileNo,
              email:userDto.email,
              userId:savedUser.Id,
              BloodDonner:userDto.BloodDonner,
              BGroupId:userDto.BGroupId,
             // otherPic:userDto.otherPic,
             // membershipImg:userDto.membershipImg,
              createdUser:userDto.userId,
              versionFlag:userDto.versionFlag
            }
            await this.profileService.createProfile(profileData);
            const hierarchyData = {
              nextLevelLoginId:userDto.createdUser,
              masterLoginId:savedUser.Id,
              createdUser:userDto.createdUser,
              versionFlag:userDto.versionFlag
            };
            const savedHierarchy = await this.hierarchyService.linkHierarchy(hierarchyData);
            if(savedHierarchy) {
              await this.userRepo.update({Id:savedUser.Id},{hierarchyId:savedHierarchy.Id})
            }
            const finalUser = await this.userRepo.findOne({
              relations:['roles','profile'],
              where:{Id:savedUser.Id}
            });
            await this.sendSMS(userDto.mobileNo, `Download netR App and connect with your Politician at Android users : https://play.google.com/store/apps/details?id=com.varahasolutions.manakandala and IOS users : https://apps.apple.com/us/app/mana-kandala/id1600830620 - Step 1 - Click on Signup Step 2 - Enter OTP Step 3 - Set a Pin if you face difficulty if you already have user ID. please click on forgot password SRI VARAHA SOLUTIONS`,process.env.BlkSMS_DOWNLOAD_TEMPID);
            await this.sendSMS(userDto.mobileNo, `Welcome to netR App, Your UserID is ${userDto.mobileNo} and Password is ${subword} to login to netR app - SRI VARAHA SOLUTIONS`,process.env.BlkSMS_NEWUSER_TEMPID);
            if(userDto.email.length > 0) {
              var anothermsg = `Welcome to NetR. Your USERID is ${userDto.mobileNo} and Password is ${subword} to login`;
              var message = ``;
              sendMailInfo(userDto.email, message, anothermsg).then(() => {
                console.log('mail sent successufully');
                return true;			
              })
              .catch((err) => {
                console.log('error in sending email ', err);
                return false;
              });
            }            
            response.status = true;
            response.data   = finalUser;
            response.statusCode = 50000;
            response.internalMessage = 'User registred successfully';
            response.intlCode = 11100;
          } else { 
            throw new ErrorResponse(11106, 'Registration failed')
          }
        } else {  
          userDto.createdUser = userDto.userId;
          var word = userDto.mobileNo.toString();          
          var subword = word.substr(word.length-4);
          userDto.pin = await bcrypt.hash(subword, 10)
          const savedUser = await this.userRepo.save({
            membershipId:userDto.membershipId,
            mobileNo:userDto.mobileNo,
            isPinSet:true,
            pin: userDto.pin,
            roleId:userDto.roleId,
            createdUser:userDto.userId,
            versionFlag:userDto.versionFlag
          });          
          if(savedUser.Id > 0) {
            const profileData = {
              firstName:userDto.firstName,
              lastName:userDto.lastName,
              gender:userDto.gender,
              dob:userDto.dob,
              address:userDto.address,
              villageId:userDto.villageId,
              mobileNo:userDto.mobileNo,
              email:userDto.email,
              userId:savedUser.Id,
              BloodDonner:userDto.BloodDonner,
              BGroupId:userDto.BGroupId,
              otherPic:userDto.otherPic,
              membershipImg:userDto.membershipImg,
              createdUser:userDto.userId,
              versionFlag:userDto.versionFlag
            }
            await this.profileService.createProfile(profileData);
            const hierarchyData = {
              nextLevelLoginId:userDto.createdUser,
              masterLoginId:savedUser.Id,
              createdUser:userDto.createdUser,
              versionFlag:userDto.versionFlag
            };
            const savedHierarchy = await this.hierarchyService.linkHierarchy(hierarchyData);
            if(savedHierarchy) {
              await this.userRepo.update({Id:savedUser.Id},{hierarchyId:savedHierarchy.Id})
            }
            const finalUser = await this.userRepo.findOne({
              relations:['roles','profile'],
              where:{Id:savedUser.Id}
            });
            await this.sendSMS(userDto.mobileNo, `Download netR App and connect with your Politician at Android users : https://play.google.com/store/apps/details?id=com.varahasolutions.manakandala and IOS users : https://apps.apple.com/us/app/mana-kandala/id1600830620 - Step 1 - Click on Signup Step 2 - Enter OTP Step 3 - Set a Pin if you face difficulty if you already have user ID. please click on forgot password SRI VARAHA SOLUTIONS`,process.env.BlkSMS_DOWNLOAD_TEMPID);
            await this.sendSMS(userDto.mobileNo, `Welcome to netR App, Your UserID is ${userDto.mobileNo} and Password is ${subword} to login to netR app - SRI VARAHA SOLUTIONS`,process.env.BlkSMS_NEWUSER_TEMPID);
            if(userDto.email.length > 0) {
              var anothermsg = `Welcome to NetR. Your USERID is ${userDto.mobileNo} and Password is ${subword} to login`;
              var message = ``;
              sendMailInfo(userDto.email, message, anothermsg).then(() => {
                console.log('mail sent successufully');
                return true;			
              })
              .catch((err) => {
                console.log('error in sending email ', err);
                return false;
              });
            }            
            response.status = true;
            response.data   = finalUser;
            response.statusCode = 50000;
            response.internalMessage = 'User registred successfully';
            response.intlCode = 11100;
          } else { 
            throw new ErrorResponse(11106, 'Registration failed')
          }
        }
      }
      return response;
    } catch (error) {
      throw error;
    }  
  }

  async signup(queryParams,signupDto:SignUpDto,memberImg):Promise<LoginStatus> {
    const response = new LoginStatus();
     try {      
      if(memberImg) {
        signupDto.membershipImg = memberImg.length > 0?memberImg[0]:null;
      } else {
        signupDto.membershipImg = null;
      }

      if(signupDto.membershipId) {
        signupDto.membershipId = signupDto.membershipId.length > 0? signupDto.membershipId:null;
      } else {
        signupDto.membershipId = null;
      }
      var today = new Date();
      today.setHours(today.getHours() + 4);
      const random = Math.floor(Math.random() * (9999 - 1000)) + 1000;
      if(queryParams.apiVersion == 1)  {
        const user = await this.userRepo.findOne({where:{mobileNo:signupDto.mobileNo, status:true}})
        if(user) {
          throw new ErrorResponse(11106, `Mobile ${signupDto.mobileNo} already registred. Try to login`)
        }
       const sentSMS = await this.sendSMS(signupDto.mobileNo, `Welcome to netR. this is your One Time Passcode ${random}`,process.env.BlkSMS_OTP_TEMPID);
       
       if(sentSMS) {
       
          const checkRecordExi = await this.uotpRepo.findOne({where:{mobileNo:signupDto.mobileNo}})
          if(checkRecordExi != undefined) {
            await this.uotpRepo.update({mobileNo:signupDto.mobileNo}, {firstName:signupDto.firstName,membershipId:signupDto.membershipId,membershipImg:signupDto.membershipImg,otp:random,otpExpire:today})
          } else {
            const sav =  await this.uotpRepo.save({
                mobileNo:signupDto.mobileNo,
                firstName:signupDto.firstName,             
                otp:random,
                otpExpire:today,
                membershipId:signupDto.membershipId,
                membershipImg:signupDto.membershipImg});
            }
          
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = `OTP sent successfully to your mobile ${signupDto.mobileNo}`;
          response.intlCode = 11100;
        } else {
          throw new ErrorResponse(11106, `Failed to send OTP to your mobile ${signupDto.mobileNo}`)
        }
      } else {
        const user = await this.userRepo.findOne({where:{mobileNo:signupDto.mobileNo, status:true}})
        if(user) {
          throw new ErrorResponse(11106, `Mobile ${signupDto.mobileNo} already registred. Try to login`)
        }
       const sentSMS = await this.sendSMS(signupDto.mobileNo, `Welcome to netR. this is your One Time Passcode ${random}`,process.env.BlkSMS_OTP_TEMPID);
       
       if(sentSMS) {
       
          const checkRecordExi = await this.uotpRepo.findOne({where:{mobileNo:signupDto.mobileNo}})
          if(checkRecordExi != undefined) {
            await this.uotpRepo.update({mobileNo:signupDto.mobileNo}, {firstName:signupDto.firstName,membershipId:signupDto.membershipId,membershipImg:signupDto.membershipImg,otp:random,otpExpire:today})
          } else {
            const sav =  await this.uotpRepo.save({
                mobileNo:signupDto.mobileNo,
                firstName:signupDto.firstName,             
                otp:random,
                otpExpire:today,
                membershipId:signupDto.membershipId,
                membershipImg:signupDto.membershipImg});
            }
          
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = `OTP sent successfully to your mobile ${signupDto.mobileNo}`;
          response.intlCode = 11100;
        } else {
          throw new ErrorResponse(11106, `Failed to send OTP to your mobile ${signupDto.mobileNo}`)
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async verifyOtp(queryParams, verifyOtpDto:VerifyOtpDto):Promise<OtpStatus> {
    const response = new OtpStatus();
    try {
      let roleNam = 'people';
      const roles = await this.roleRepo.findOne({where:{roleName:Raw(alias => `UPPER(role_name) = '${roleNam.toLocaleUpperCase()}'`),}})
      var today = new Date();
      if(queryParams.apiVersion == 1) {
        const userByOtp = await this.uotpRepo.findOne({
          where:{ mobileNo:verifyOtpDto.mobileNo, otp:verifyOtpDto.otp, otpExpire:MoreThan(today)}
        })
        if(userByOtp) {
          const userExist = await this.userRepo.findOne({where:{mobileNo:verifyOtpDto.mobileNo, status:true}})
          if(!userExist) {
            const saveUser = await this.userRepo.save({
              mobileNo:verifyOtpDto.mobileNo,
              roleId:roles.Id,
              membershipId:userByOtp.membershipId,              
              versionFlag:queryParams.apiVersion
            });
            const saveProfile = await this.profileService.createProfile({
              firstName:userByOtp.firstName,
              mobileNo:verifyOtpDto.mobileNo,
              userId:saveUser.Id,
              membershipImg:userByOtp.membershipImg
            });            
          } 
          await this.uotpRepo.delete({mobileNo:verifyOtpDto.mobileNo})
          const user = await this.userRepo.findOne({where:{mobileNo:verifyOtpDto.mobileNo, status:true}})
          const data = {
            userId:user.Id,
            mobileNo:user.mobileNo,
            roleId:user.roleId
          }
          response.status = true;
          response.statusCode = 50000;
          response.data = data;
          response.internalMessage = 'OTP verified successfully';
          response.intlCode = 11100;
          response.authtoken = this._createToken(user);
        } else {
          throw new ErrorResponse(11106,'Unmatched otp or Otp expired');
        }
      } else {
        const userByOtp = await this.uotpRepo.findOne({
          where:{ mobileNo:verifyOtpDto.mobileNo, otp:verifyOtpDto.otp, otpExpire:MoreThan(today)}
        })
        if(userByOtp) {
          const userExist = await this.userRepo.findOne({where:{mobileNo:verifyOtpDto.mobileNo, status:true}})
          if(!userExist) {
            const saveUser = await this.userRepo.save({
              mobileNo:verifyOtpDto.mobileNo,
              roleId:roles.Id,
              membershipId:userByOtp.membershipId,              
              versionFlag:queryParams.apiVersion
            });
            const saveProfile = await this.profileService.createProfile({
              firstName:userByOtp.firstName,
              mobileNo:verifyOtpDto.mobileNo,
              userId:saveUser.Id,
              membershipImg:userByOtp.membershipImg
            });            
          } 
          await this.uotpRepo.delete({mobileNo:verifyOtpDto.mobileNo})
          const user = await this.userRepo.findOne({where:{mobileNo:verifyOtpDto.mobileNo, status:true}})
          const data = {
            userId:user.Id,
            mobileNo:user.mobileNo,
            roleId:user.roleId
          }
          response.status = true;
          response.statusCode = 50000;
          response.data = data;
          response.internalMessage = 'OTP verified successfully';
          response.intlCode = 11100;
          response.authtoken = this._createToken(user);
        } else {
          throw new ErrorResponse(11106,'Unmatched otp or Otp expired');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async findByLogin(queryParams,loginDto: LoginUserDto): Promise<LoginStatus> { 
    const response = new LoginStatus();
    try {
      const user = await this.userRepo.findOne({ 
        relations:['roles','profile'],
        where: { mobileNo:loginDto.mobileNo, status:true } });   
      if(queryParams.apiVersion == 1) {
        if (!user ) {
          const prof = await this.profileService.getProfileByEmail(loginDto.mobileNo);          
          if(!prof) {
            throw new ErrorResponse(11106,'User not found');
          } else {
            const user1 = await this.userRepo.findOne({ 
              relations:['roles','profile'],
              where: { mobileNo:prof.user.mobileNo, status:true } });
            if (!prof.user.isPinSet) {
              throw new ErrorResponse(11106,'Pin not yet set. Try to set pin by using forgot password');
            } else {
              let checkPassword = await bcrypt.compareSync(loginDto.pin, prof.user.pin);
              if (!checkPassword ) {
                throw new ErrorResponse(11106,'Unmatched password');
              } 
              const userById = {
                userId:prof.userId,
                mobileNo:prof.user.mobileNo,
                email:prof.email,
                firstName:prof.firstName,
                roleId:prof.user.roleId,
                roleName:prof.user.roles.roleName
              }
              await this.userRepo.update(prof.user.Id,{fcmToken:loginDto.fcmToken});
              response.status = true;
              response.data= userById;
              response.statusCode = 50000;
              response.internalMessage = 'login successfully';
              response.intlCode = 11100;
              response.authtoken = this._createToken(user1);
            }                  
          }
        } else {
          if (!user.isPinSet) {
            throw new ErrorResponse(11106,'Pin not yet set. Try to set pin by using forgot password');
          } else {
            let checkPassword = await bcrypt.compareSync(loginDto.pin, user.pin);
            if (!checkPassword ) {
              throw new ErrorResponse(11106,'Unmatched password');
            } 
            const userById = {
              userId:user.Id,
              mobileNo:user.mobileNo,
              email:user.profile.email,
              firstName:user.profile.firstName,
              roleId:user.roleId,
              roleName:user.roles.roleName
            }
            await this.userRepo.update(user.Id,{fcmToken:loginDto.fcmToken});
            response.status = true;
            response.data= userById;
            response.statusCode = 50000;
            response.internalMessage = 'login successfully';
            response.intlCode = 11100;
            response.authtoken = this._createToken(user);
          }
        }        
      }else {
        if (!user ) {
          console.log("email loop");
          const prof = await this.profileService.getProfileByEmail(loginDto.mobileNo);          
          if(!prof) {
            throw new ErrorResponse(11106,'User not found');
          } else {
            const user1 = await this.userRepo.findOne({ 
              relations:['roles','profile'],
              where: { mobileNo:prof.user.mobileNo, status:true } });
            if (!prof.user.isPinSet) {
              throw new ErrorResponse(11106,'Pin not yet set. Try to set pin by using forgot password');
            } else {
              let checkPassword = await bcrypt.compareSync(loginDto.pin, prof.user.pin);
              if (!checkPassword ) {
                throw new ErrorResponse(11106,'Unmatched password');
              } 
              const userById = {
                userId:prof.userId,
                mobileNo:prof.user.mobileNo,
                email:prof.email,
                firstName:prof.firstName,
                roleId:prof.user.roleId,
                roleName:prof.user.roles.roleName
              }
              await this.userRepo.update(prof.user.Id,{fcmToken:loginDto.fcmToken});
              response.status = true;
              response.data= userById;
              response.statusCode = 50000;
              response.internalMessage = 'login successfully';
              response.intlCode = 11100;
              response.authtoken = this._createToken(user1);
            }                  
          }
        } else {
          if (!user.isPinSet) {
            throw new ErrorResponse(11106,'Pin not yet set. Try to set pin by using forgot password');
          } else {
            let checkPassword = await bcrypt.compareSync(loginDto.pin, user.pin);
            if (!checkPassword ) {
              throw new ErrorResponse(11106,'Unmatched password');
            } 
            const userById = {
              userId:user.Id,
              mobileNo:user.mobileNo,
              email:user.profile.email,
              firstName:user.profile.firstName,
              roleId:user.roleId,
              roleName:user.roles.roleName
            }
            await this.userRepo.update(user.Id,{fcmToken:loginDto.fcmToken});
            response.status = true;
            response.data= userById;
            response.statusCode = 50000;
            response.internalMessage = 'login successfully';
            response.intlCode = 11100;
            response.authtoken = this._createToken(user);
          }
        }        
      }
      return response;
    } catch (error) {
      throw error;
    }    
  }

  private _createToken({ mobileNo }: UserDto): any {
    const user: JwtPayload = { mobileNo };    
    const accessToken = this.jwtService.sign(user); 
    return accessToken;
    /* return {
      expiresIn: '1h',//process.env.EXPIRESIN,
      accessToken,    
    }; */  
  }

  async setPin(queryParams, setPinDto:SetPinDto, request:Request):Promise<UserStatus> {
    const response = new UserStatus();
    try {
      setPinDto.pin = await bcrypt.hash(setPinDto.pin, 10)
      if(queryParams.apiVersion == 1) {
        const user = await this.userRepo.findOne({
          where: {mobileNo:setPinDto.mobileNo, status:true},
        });
        if(!user) {
          throw new ErrorResponse(11106,'Mobile number not registred');
        }
        const updatePin = await this.userRepo.update(user.Id,{pin:setPinDto.pin, isPinSet:true});
        if(updatePin) {
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'Pin set successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Pin set failed')
        }
      } else {
        const user = await this.userRepo.findOne({
          where: {mobileNo:setPinDto.mobileNo, status:true},
        });
        if(!user) {
          throw new ErrorResponse(11106,'Mobile number not registred');
        }
        const updatePin = await this.userRepo.update(user.Id,{pin:setPinDto.pin, isPinSet:true});
        if(updatePin) {
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'Pin set successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Pin set failed')
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async resendOtp(queryParams,otpDto:OtpDto):Promise<UserStatus> {
    const response = new UserStatus();
    try {
      var today = new Date();
      today.setHours(today.getHours() + 4);
      const random = Math.floor(Math.random() * (9999 - 1000)) + 1000;  
      const sentSMS = await this.sendSMS(otpDto.mobileNo, `Welcome to netR. this is your One Time Passcode ${random}`,process.env.BlkSMS_OTP_TEMPID);      
      if(queryParams.apiVersion == 1) {
        if(sentSMS) {
          const user = await this.uotpRepo.findOne({
            where: {mobileNo:otpDto.mobileNo},
          });
          if(!user) {
            await this.uotpRepo.save({
              mobileNo:otpDto.mobileNo,
              otp:random,
              otpExpire:today
            })
          } else {
            await this.uotpRepo.update({mobileNo:otpDto.mobileNo},{otp:random, otpExpire:today})
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = `Otp sent successfully to your mobile ${otpDto.mobileNo}`;
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(11106, `Failed to send OTP to your mobile ${otpDto.mobileNo}`)
        }
        return response;
      } else {
        if(sentSMS) {
          const user = await this.uotpRepo.findOne({
            where: {mobileNo:otpDto.mobileNo},
          });
          if(!user) {
            await this.uotpRepo.save({
              mobileNo:otpDto.mobileNo,
              otp:random,
              otpExpire:today
            })
          } else {
            await this.uotpRepo.update({mobileNo:otpDto.mobileNo},{otp:random, otpExpire:today})
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = `Otp sent successfully to your mobile ${otpDto.mobileNo}`;
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(11106, `Failed to send OTP to your mobile ${otpDto.mobileNo}`)
        }
        return response;
      } 
    } catch (error) {
      throw error;
    }
  }

  async forgotPassword(queryParams,otpDto:OtpDto):Promise<LoginStatus> {
    const response = new LoginStatus();
    try {
      var today = new Date();
      today.setHours(today.getHours() + 4);
      const random = Math.floor(Math.random() * (9999 - 1000)) + 1000;
      if(queryParams.apiVersion == 1) {
        const user = await this.userRepo.findOne({where:{mobileNo:otpDto.mobileNo, status:true}})
        if(!user) {
          throw new ErrorResponse(11106, `Mobile ${otpDto.mobileNo} not registred.`)
        }
        const sentSMS = await this.sendSMS(otpDto.mobileNo, `Welcome to netR. this is your One Time Passcode ${random}`,process.env.BlkSMS_OTP_TEMPID);
        if(sentSMS) {
          const checkRecordExi = await this.uotpRepo.findOne({where:{mobileNo:otpDto.mobileNo}})
          if(checkRecordExi) {
            await this.uotpRepo.update({mobileNo:otpDto.mobileNo}, {otp:random,otpExpire:today})
          } else {
            await this.uotpRepo.save({mobileNo:otpDto.mobileNo,otp:random,otpExpire:today})
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = `OTP sent successfully to your mobile ${otpDto.mobileNo}`;
          response.intlCode = 11100;
        } else {
          throw new ErrorResponse(11106, `Failed to send OTP to your mobile ${otpDto.mobileNo}`)
        }
      } else {
        const user = await this.userRepo.findOne({where:{mobileNo:otpDto.mobileNo, status:true}})
        if(!user) {
          throw new ErrorResponse(11106, `Mobile ${otpDto.mobileNo} not registred.`)
        }
        const sentSMS = await this.sendSMS(otpDto.mobileNo, `Welcome to netR. this is your One Time Passcode ${random}`,process.env.BlkSMS_OTP_TEMPID);
        if(sentSMS) {
          const checkRecordExi = await this.uotpRepo.findOne({where:{mobileNo:otpDto.mobileNo}})
          if(checkRecordExi) {
            await this.uotpRepo.update({mobileNo:otpDto.mobileNo}, {otp:random,otpExpire:today})
          } else {
            await this.uotpRepo.save({mobileNo:otpDto.mobileNo,otp:random,otpExpire:today})
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = `OTP sent successfully to your mobile ${otpDto.mobileNo}`;
          response.intlCode = 11100;
        } else {
          throw new ErrorResponse(11106, `Failed to send OTP to your mobile ${otpDto.mobileNo}`)
        }
      }      
      return response;
    } catch (error) {
      throw error;
    }
  }

  async deleteUser(queryParams, userIdDto:UserIdDto, request:Request):Promise<LoginStatus> {
    const response = new LoginStatus();
    try {
      if(queryParams.apiVersion == 1) {
        const updateUser  = await this.userRepo.update(userIdDto.userId,{status:false})
        if(updateUser) {
          await this.profileService.deleteUser(userIdDto.userId);
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'user deleted successfully ';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99908,'user delete failed');
        }
      } else {
        const updateUser  = await this.userRepo.update(userIdDto.userId,{status:false})
        if(updateUser) {
          await this.profileService.deleteUser(userIdDto.userId);
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'user deleted successfully ';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99908,'user delete failed');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async changeUserRole(queryParams, userRoleDto:UserRoleDto, request:Request):Promise<LoginStatus> {
    const response = new LoginStatus();
    try {
      const user = await this.userRepo.findOne({
        relations:['profile'],
        where:{Id:userRoleDto.updatedUser}
      })
      if(queryParams.apiVersion == 1) {
        const updateUser  = await this.userRepo.update(userRoleDto.userId,{roleId:userRoleDto.roleId})
        if(updateUser) {
          const user1 = await this.userRepo.findOne({
            relations:['roles'],
            where:{Id:userRoleDto.userId}
          })
          let msg = {
            to : `${user1.fcmToken}`,
            collapse_key : "type_a",
            notification : {
                body : `Sri ${user.profile.firstName} Changed Your Role ${user1.roles.roleName}`,
                title: "Change Role"
            },
            data : {
                body : `Sri ${user.profile.firstName} Changed Your Role ${user1.roles.roleName}`,
                title: "Change Role",
                key_1 : "",
                key_2 : ""
            }
          }
          await this.notifyRepo.save({
            title:'Change Role',
            message:`Sri ${user.profile.firstName} Changed Your Role ${user1.roles.roleName}`,
            typeId:3,
            userId:userRoleDto.userId,
            targetId:0,
            status:true
        })
          if(user1.fcmToken) {
            
            const nt = await this.sendNotify(msg);
        }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'user role changed successfully ';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99908,'user role change failed');
        }
      } else {
        const updateUser  = await this.userRepo.update(userRoleDto.userId,{roleId:userRoleDto.roleId})
        if(updateUser) {
          const user1 = await this.userRepo.findOne({
            relations:['roles'],
            where:{Id:userRoleDto.userId}
          })
          let msg = {
            to : `${user1.fcmToken}`,
            collapse_key : "type_a",
            notification : {
                body : `Sri ${user.profile.firstName} Changed Your Role ${user1.roles.roleName}`,
                title: "Change Role"
            },
            data : {
                body : `Sri ${user.profile.firstName} Changed Your Role ${user1.roles.roleName}`,
                title: "Change Role",
                key_1 : "",
                key_2 : ""
            }
          }
          await this.notifyRepo.save({
            title:'Change Role',
            message:`Sri ${user.profile.firstName} Changed Your Role ${user1.roles.roleName}`,
            typeId:3,
            userId:userRoleDto.userId,
            targetId:0,
            status:true
        })
          if(user1.fcmToken) {
            
            const nt = await this.sendNotify(msg);
        }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'user role changed successfully ';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99908,'user role change failed');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }
     

  async getAllUsers(queryParams):Promise<AllUserStatus>{
    const response = new AllUserStatus();
    try {
      if(queryParams.apiVersion == 1) {
        const users = await this.userRepo.find({
          relations:['roles','profile','hierarchy'],
          where:{status:true},
          order: {createdAt: "DESC"},
          skip:queryParams.skip,
          take: 10
        });
        if(users) {
          response.status = true;
          response.data = users;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      } else {
        const users = await this.userRepo.find({
          relations:['roles','profile','hierarchy'],
          where:{status:true},
          order: {createdAt: "DESC"},
          skip:queryParams.skip,
          take: 10
        });
        if(users) {
          response.status = true;
          response.data = users;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async SetPintoBulk(queryParams):Promise<AllUserStatus>{
    const response = new AllUserStatus();
    try {
      if(queryParams.apiVersion == 1) {
        const users = await this.userRepo.find({
          where:{status:true,isPinSet:false},
          order: {createdAt: "DESC"}
        });
        if(users) {
          const promises = users.map(async (u) => {
            var num = '1234';
            let pin = await bcrypt.hash(num, 10);
            await this.userRepo.update(u.Id,{pin:pin, isPinSet:true});
            await this.sendSMS(u.mobileNo, `Download netR App and connect with your Politician at Android users : https://play.google.com/store/apps/details?id=com.varahasolutions.manakandala and IOS users : https://apps.apple.com/us/app/mana-kandala/id1600830620 - Step 1 - Click on Signup Step 2 - Enter OTP Step 3 - Set a Pin if you face difficulty if you already have user ID. please click on forgot password SRI VARAHA SOLUTIONS`,process.env.BlkSMS_DOWNLOAD_TEMPID);
            await this.sendSMS(u.mobileNo, `Welcome to netR App, Your UserID is ${u.mobileNo} and Password is ${num} to login to netR app - SRI VARAHA SOLUTIONS`,process.env.BlkSMS_NEWUSER_TEMPID);
            
        });   
        const da = await Promise.all(promises);
        da.map((f) => {  
            
        }) 
         response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'Pin set to all users successfully';
          response.intlCode = 11108; 
        } else {
          throw new ErrorResponse(99998, 'something went wrong');
        }
      } else {
        const users = await this.userRepo.find({
          where:{status:true,isPinSet:false},
          order: {createdAt: "DESC"}
        });
        if(users) {
          const promises = users.map(async (u) => {
            var num = '1234';
            let pin = await bcrypt.hash(num, 10);
            await this.userRepo.update(u.Id,{pin:pin, isPinSet:true});
            await this.sendSMS(u.mobileNo, `Download netR App and connect with your Politician at Android users : https://play.google.com/store/apps/details?id=com.varahasolutions.manakandala and IOS users : https://apps.apple.com/us/app/mana-kandala/id1600830620 - Step 1 - Click on Signup Step 2 - Enter OTP Step 3 - Set a Pin if you face difficulty if you already have user ID. please click on forgot password SRI VARAHA SOLUTIONS`,process.env.BlkSMS_DOWNLOAD_TEMPID);
            await this.sendSMS(u.mobileNo, `Welcome to netR App, Your UserID is ${u.mobileNo} and Password is ${num} to login to netR app - SRI VARAHA SOLUTIONS`,process.env.BlkSMS_NEWUSER_TEMPID);
            
        });   
        const da = await Promise.all(promises);
        da.map((f) => {  
            
        }) 
         response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'Pin set to all users successfully';
          response.intlCode = 11108; 
        } else {
          throw new ErrorResponse(99998, 'something went wrong');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getActiveUsersCount(queryParams): Promise<UserStatusWiseResponseModel> {
    const response = new UserStatusWiseResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        const usersStatusWiseCount = await getConnection()
        .createQueryBuilder()
        .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
        .from(UserEntity, "UserEntity")
        .orderBy('status','ASC')
        .getRawOne();     
        if (response) {
          response.status = true;
          response.active = usersStatusWiseCount.activeCount;
          response.inActive = usersStatusWiseCount.inActiveCount;
          response.total = usersStatusWiseCount.cnt;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      } else {
        const usersStatusWiseCount = await getConnection()
        .createQueryBuilder()
        .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
        .from(UserEntity, "UserEntity")
        .orderBy('status','ASC')
        .getRawOne();     
        if (response) {
          response.status = true;
          response.active = usersStatusWiseCount.activeCount;
          response.inActive = usersStatusWiseCount.inActiveCount;
          response.total = usersStatusWiseCount.cnt;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      }      
      return response;
    } catch (err) {
      throw err;
    }
  }

  async getSearchUser(queryParams,userSearchDto:userSearchDto):Promise<searchResponseModel> {
    const response = new searchResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        let finalData : any[] = [];
        const data = await this.profileService.getSearchUser(userSearchDto.searchTerm);
        if(data) {
          const final = data.map((p) => {
            finalData.push({
              userId:p.userId,
              firstName:p.firstName,
              mobileNo:p.mobileNo
            })
          })
          response.status = true;
          response.data = finalData;
          response.statusCode = 50000;
          response.internalMessage = 'data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      } else {
        let finalData : any[] = [];
        const data = await this.profileService.getSearchUser(userSearchDto.searchTerm);
        if(data) {
          const final = data.map((p) => {
            finalData.push({
              userId:p.userId,
              firstName:p.firstName,
              mobileNo:p.mobileNo
            })
          })
          response.status = true;
          response.data = finalData;
          response.statusCode = 50000;
          response.internalMessage = 'data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      }
      return response;
    } catch(error) {
      throw error;
    }
  }

  async getDonorslist(queryParams):Promise<searchResponseModel> {
    const response = new searchResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        let finalData : any[] = [];
        const data = await this.profileService.getDonorslist(queryParams.BGroupId,queryParams.villageId,queryParams.skip);
        if(data) {
          const final = data.map((p) => {
            if(p.bgroup) {
              var bnae = p.bgroup.name
            } else {
              var bnae = '';
            }
            if(p.village) {
              var vnae = p.village.villageName
            } else {
              var vnae = '';
            }
            finalData.push({
              userId:p.userId,
              firstName:p.firstName,
              lastName: p.lastName,
              mobileNo:p.mobileNo,
              bloodGroupName:bnae,
              villageId:p.villageId,
              villageName:vnae
            })
          })
          response.status = true;
          response.data = finalData;
          response.statusCode = 50000;
          response.internalMessage = 'data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      } else {
        let finalData : any[] = [];
        const data = await this.profileService.getDonorslist(queryParams.BGroupId,queryParams.villageId,queryParams.skip);
        if(data) {
          const final = data.map((p) => {
            if(p.bgroup) {
              var bnae = p.bgroup.name
            } else {
              var bnae = '';
            }
            if(p.village) {
              var vnae = p.village.villageName
            } else {
              var vnae = '';
            }
            finalData.push({
              userId:p.userId,
              firstName:p.firstName,
              lastName: p.lastName,
              mobileNo:p.mobileNo,
              bloodGroupName:bnae,
              villageId:p.villageId,
              villageName:vnae
            })
          })
          response.status = true;
          response.data = finalData;
          response.statusCode = 50000;
          response.internalMessage = 'data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      }
      return response;
    } catch(error) {
      throw error;
    }
  }
}
